/**
 * Lead Type ID Normalization
 * 
 * Provides canonical lead type IDs and normalization functions
 * to ensure consistent matching across the system.
 */

// Canonical lead type IDs
export const LEAD_TYPE_IDS = {
  // Life Insurance (canonical)
  LIFE_FEX: 'life_fex',
  LIFE_IUL: 'life_iul',
  LIFE_MP: 'life_mp',
  // Mortgage (canonical)
  MORTGAGE_PURCHASE: 'mortgage_purchase',
  MORTGAGE_REFI: 'mortgage_refi',
  MORTGAGE_HELOC: 'mortgage_heloc',
  MORTGAGE_REVERSE: 'mortgage_reverse',
} as const;

// Alias mapping for normalization
const LEAD_TYPE_ALIASES: Record<string, string> = {
  // Final Expense aliases
  'fex': LEAD_TYPE_IDS.LIFE_FEX,
  'fe': LEAD_TYPE_IDS.LIFE_FEX,
  'final_expense': LEAD_TYPE_IDS.LIFE_FEX,
  'final expense': LEAD_TYPE_IDS.LIFE_FEX,
  'finalexpense': LEAD_TYPE_IDS.LIFE_FEX,
  
  // IUL aliases
  'iul': LEAD_TYPE_IDS.LIFE_IUL,
  'indexed_universal_life': LEAD_TYPE_IDS.LIFE_IUL,
  'indexed universal life': LEAD_TYPE_IDS.LIFE_IUL,
  
  // Mortgage Protection aliases
  'mortgage_protection': LEAD_TYPE_IDS.LIFE_MP,
  'mortgage protection': LEAD_TYPE_IDS.LIFE_MP,
  'mp': LEAD_TYPE_IDS.LIFE_MP,
  'mortgageprotection': LEAD_TYPE_IDS.LIFE_MP,
  
  // Mortgage lead types
  'purchase': LEAD_TYPE_IDS.MORTGAGE_PURCHASE,
  'refinance': LEAD_TYPE_IDS.MORTGAGE_REFI,
  'refi': LEAD_TYPE_IDS.MORTGAGE_REFI,
  'cashout': LEAD_TYPE_IDS.MORTGAGE_REFI,
  'cash out': LEAD_TYPE_IDS.MORTGAGE_REFI,
  'rate & term': LEAD_TYPE_IDS.MORTGAGE_REFI,
  'rate and term': LEAD_TYPE_IDS.MORTGAGE_REFI,
  'heloc': LEAD_TYPE_IDS.MORTGAGE_HELOC,
  'reverse': LEAD_TYPE_IDS.MORTGAGE_REVERSE,
  'reverse mortgage': LEAD_TYPE_IDS.MORTGAGE_REVERSE,
};

/**
 * Normalize a lead type ID to its canonical form.
 * Returns the original ID if no alias mapping exists.
 */
export function normalizeLeadTypeId(leadTypeId: string): string {
  if (!leadTypeId) return leadTypeId;
  const normalized = leadTypeId.toLowerCase().trim();
  return LEAD_TYPE_ALIASES[normalized] ?? leadTypeId;
}
